export const DEFAULT_WORKSPACE_SIDEBAR_BRANDING = {
	sidebarBackgroundColor: '#ffffff',
	sidebarTextColor: '#061a38',
	sidebarHoverTextColor: '#0bc5ea',
	sidebarActiveTextColor: '#0bc5ea',
};

export const getDefaultWorkspaceBranding = () => ({
	...DEFAULT_WORKSPACE_SIDEBAR_BRANDING,
	logo: '',
	primaryColor: '',
	useBrandingOnClientPortal: false,
});
